import React, { FC, useState } from 'react';
import cls from 'classnames';
import { IconComp } from '../SwapKiwi/IconComponent';
import { ReactComponent as Search } from '../../assets/svg/icons/search-sm.svg';
export interface SearchBarProps {
  className?: string;
  onChange: (searchText: string) => void;
  disabled?: boolean;
  error?: boolean;
}

export const SearchBar: FC<SearchBarProps> = ({ className, onChange, disabled, error }) => {
  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.value);
  };
  const [focus, setFocus] = useState<boolean>(false);

  return (
    <div
      className={cls(
        'relative sk-search-bar bg-white border border-cloud-400 rounded-xl',
        {
          'border-kiwi-400': focus,
          'border-cloud-300 cursor-not-allowed bg-cloud-50': disabled,
          'border-strawberry-400': error,
        },
        className,
      )}
    >
      <IconComp
        size={24}
        icon={Search}
        className="absolute text-cloud-400 stroke-current top-1/2 left-2 transform -translate-y-1/2"
      />
      <input
        className={cls('block text-lg text-cloud-900 w-full p-2 pl-3 rounded-xl', {
          'cursor-not-allowed bg-cloud-50': disabled,
        })}
        disabled={disabled}
        placeholder="Search"
        onChange={onChangeText}
        onFocus={(): void => {
          !disabled && setFocus(true);
        }}
        onBlur={(): void => setFocus(false)}
      />
    </div>
  );
};
